import { render, staticRenderFns } from "./RequisitionView.vue?vue&type=template&id=59b0945a"
import script from "./RequisitionView.vue?vue&type=script&lang=js"
export * from "./RequisitionView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports